export default ({ request }) => ({
  // 获取年度产奶热度图数据
  getAnnualHeatmap(params) {
    return request({
      url: '/platform/v1/farm_daily_production/annual-heatmap',
      method: 'get',
      params: params
    })
  },

  // 获取产奶个体数量曲线数据
  getItemCountCurve(params) {
    return request({
      url: '/platform/v1/farm_daily_production/item-count-curve',
      method: 'get',
      params: params
    })
  },

  // 获取产奶量曲线数据
  getProductionCurve(params) {
    return request({
      url: '/platform/v1/farm_daily_production/production-curve',
      method: 'get',
      params: params
    })
  },
  
  // 手动触发聚合
  aggregateDailyRecords(data) {
    return request({
      url: '/platform/v1/farm_daily_production/aggregate',
      method: 'post',
      data: data
    })
  },
  
  // 获取产奶时长排名
  getProducingDurationRanking(params) {
    return request({
      url: '/platform/v1/production_records/producing-duration-ranking',
      method: 'get',
      params: params
    })
  },

  // 添加手动录入的日产记录
  addManualRecord(data) {
    return request({
      url: '/platform/v1/farm_daily_production/add-manual',
      method: 'post',
      data: data
    })
  }
})